import { render, staticRenderFns } from "./salesBankView.vue?vue&type=template&id=65987129&scoped=true"
import script from "./salesBankView.vue?vue&type=script&lang=js"
export * from "./salesBankView.vue?vue&type=script&lang=js"
import style0 from "./salesBankView.vue?vue&type=style&index=0&id=65987129&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65987129",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/saas_fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65987129')) {
      api.createRecord('65987129', component.options)
    } else {
      api.reload('65987129', component.options)
    }
    module.hot.accept("./salesBankView.vue?vue&type=template&id=65987129&scoped=true", function () {
      api.rerender('65987129', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sales/salesReps/salesBankView.vue"
export default component.exports